import { render, staticRenderFns } from "./TheMainSidebar.vue?vue&type=template&id=aa9093d6&scoped=true&"
import script from "./TheMainSidebar.vue?vue&type=script&lang=js&"
export * from "./TheMainSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheMainSidebar.vue?vue&type=style&index=0&id=aa9093d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9093d6",
  null
  
)

export default component.exports